export class ScheduleModel {
    id = 0;
    name = "";
    notificationTemplateId = 0;
    notificationScheduleOffsetId = 0
    notificationScheduleTriggerDateId = 0;
    isOffsetBeforeTriggerDate = null as boolean | null;
    isDraft = true;
    sleepTimeHandlingType = MessageSchedulingSleepTimeHandlingTypeEnum.After;

    distributionChannelTypeIds = [] as number[];
    otaIds = [] as number[];
    salesChannelIds = [] as number[];
    paymentMeanIds = [] as number[];
    reservationStatusIds = [] as number[];
    propertiesIds = [] as number[];
}

export enum MessageSchedulingSleepTimeHandlingTypeEnum {
    Ignore = 0,
    Before = 1,
    After = 2,
}